import RankTypes from './types';
import { Reducer } from 'redux';
import { HostessRankState, HostessRankDispatchAction } from './state';

const initialState : HostessRankState = {
    rank: ''
}

const RankReducer : Reducer<HostessRankState, HostessRankDispatchAction> = 
    (state = initialState, action) => {
        switch(action.type) {
            case RankTypes.FETCH_START:
                return state
            case RankTypes.FETCH_SUCCESS:
                return action.payload
            default:
                return state
        }
    }

export default RankReducer;